export const organizationInfoStyle = {
	container: {
		display: 'flex',
		gap: '12px',
		flexDirection: 'column',
	},

	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},

	infoRow: {
		display: 'flex',
		alignItems: 'center',
	},
	label: {
		color: 'var(--neutral-300)',
		width: '200px',
	},
	value: {},
	statusDeactivated: {
		fontWeight: 'bold',
	},
	statusActive: {
		fontWeight: 'bold',
	},
	restoreContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		padding: '16px',
		backgroundColor: 'var(--neutral-50)',
		border: '1px solid var(--neutral-100)',
		borderRadius: '8px',
		marginTop: '40px',
	},
	restoreTextContainer: {},

	restoreText: {
		color: 'var(--neutral-500)',
		fontWeight: '400',
	},
};
